import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SelectMultiple from "src/components/SelectMultiple/SelectMultiple";
import { expandJSON } from "src/helpers/helper";
import { AET_DASHBOARD } from "src/redux/config/links";

const SelectFleet = ({
  selectedCompany,
  loadFleet,
  setLoadFleet,
  onChangeSelectedFleet,
  selectedFleet,
  onRemoveSelectedFleet,
  disabled
}) => {
  //   const [loadFleet, setLoadFleet] = useState(false);
  const { authStore } = useSelector((state) => ({
    authStore: state.authStore,
  }));

  const [filter, setFilter] = useState([]);
  const [page, setPage] = useState({
    of: 1,
    size: 20,
  });

  const [loadingFleet, setLoadingFleet] = useState(false);
  const [fleetList, setFleetList] = useState(null);

  const onFleetList = useCallback(
    ({ page, sort, filter, show = [], groupby = [] }) => {
      setLoadingFleet(true);

      const query = expandJSON({
        page,
        sort,
        filter,
        show,
        groupby,
      })
        .map((item) => `${item.label}=${encodeURI(item.value)}`)
        .join("&");
      axios({
        url: `${AET_DASHBOARD}?${query}`,
        method: "POST",
        headers: {
          Authorization: authStore.authData.result.token,
        },
      })
        .then((result) => {
          setLoadingFleet(false);
          setFleetList(result.data);
        })
        .catch(() => {
          setLoadingFleet(false);
        });
    },
    [authStore.authData.result.token]
  );

  //   useEffect(() => {
  //       setLoadFleet(true);
  //       console.log("yuguuuuu")
  //   }, [loadFleet, selectedCompany]);
  useEffect(() => {
    if (loadFleet) {
      setLoadFleet(false);
      onFleetList({
        page: page,
        sort: [],
        filter: {
          ...filter,
          leftJoin_company_name: {
            in: (!!selectedCompany ? selectedCompany : []).map(
              (item) => item.value
            ),
          },
        },
        show: ["leftJoin_fleet_reg_number", "leftJoin_company_name"],
        groupby: ["leftJoin_fleet_reg_number", "leftJoin_company_name"],
      });
    }
  }, [filter, page, loadFleet, onFleetList, selectedCompany, setLoadFleet]);
  return (
    <>
      <SelectMultiple
        disabled={disabled}
        placeholder="Fleet"
        name={"fleet"}
        onChange={(e) => onChangeSelectedFleet(e, fleetList)}
        option={[
          { label: "All", value: "All" },
          ...(!!fleetList ? [...fleetList.result.data] : []).map((item) => ({
            label: `${item.leftJoin_company_name} - ${item.leftJoin_fleet_reg_number}`,
            value: item.leftJoin_fleet_reg_number,
          })),
        ]}
        value={selectedFleet}
        page={page}
        totalPage={
          Math.ceil(
            ((!!fleetList ? fleetList.result.total : 1) ?? 1) / page.size
          ) ?? 1
        }
        onPage={(page) => {
          setPage(page);
          setLoadFleet(true);
        }}
        onKeypress={(value) => {
          setFilter({
            ...filter,
            leftJoin_fleet_reg_number: `${value}%`,
          });
          setLoadFleet(true);
        }}
        loading={loadingFleet}
      />
      
      {selectedFleet.map((item, index) => (
        <React.Fragment key={index}>
          <button
            onClick={() => onRemoveSelectedFleet(item)}
            className="btn btn-primary"
            type="button"
          >
            {item.label} <span aria-hidden="true">&times;</span>
          </button>{" "}
        </React.Fragment>
      ))}
    </>
  );
};

export default SelectFleet;
